// removed by extract-text-webpack-plugin
module.exports = {"InputIcon":"InputIcon--2ZQvL"};